<template>
  <v-app v-if="loggedIn">
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      fixed
      dark
      width="270"
      class="pl-nav"
      app>
      <v-list v-if="currentCourse">
        <v-list-group
          :value="false"
          v-for="(category, category_index) in currentCategories"
          :key="category_index"
          no-action
          dark>
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ category.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-for="(subcategory, subcategory_index) in subcategoriesByCategoryId(category.id)"
            :key="subcategory_index"
            :to="{
              name: 'filters_path',
              params: {
                categoryId: subcategory.categoryId,
                subcategoryId: subcategory.id,
              }
            }"
            ripple>
            <v-list-tile-content>
              <v-list-tile-title>{{ subcategory.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar class="pl-toolbar-nav" flat dark fixed>
      <v-toolbar-side-icon
        dark
        color="lighten-3"
        @click.prevent="drawer = !drawer"/>

      <v-toolbar-title>
        <router-link :to="{ name: 'home' }">
          <img
            src="../../assets/logo.png"
            alt="PokerLAB Range Selection"
            class="pl-logo">
        </router-link>
      </v-toolbar-title>

      <v-menu offset-y>
        <v-btn color="success" depressed slot="activator">
          <span>{{ selectedCourseTitle }}</span>
          <v-icon right dark>expand_more</v-icon>
        </v-btn>

        <v-list>
          <v-list-tile
            v-for="course in courses"
            :key="course.id"
            @click="selectCourse(course)">
            <v-list-tile-title v-text="course.text"></v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-spacer></v-spacer>

      <v-btn
        class="hidden-sm-and-down mr-2"
        flat
        to="/decks">
          <v-icon left dark>archive</v-icon> Decks
      </v-btn>

      <v-btn
        target="_blank"
        class="hidden-sm-and-down mr-2"
        flat
        href="https://membros.pokerlab.com.br">
          <v-icon left dark>reply</v-icon> Área de Membros
      </v-btn>

      <v-menu offset-y>
        <v-avatar
          slot="activator"
          :size="35"
          color="grey lighten-4"
          class="ml-3">
          <img :src="currentUser.avatar" alt="avatar" v-if="currentUser">
        </v-avatar>

        <v-list>
          <v-list-tile @click="logout">
            <v-list-tile-title>Sair</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-content>
      <router-view
        :key="$route.fullPath"
        :courses="courses"
        :hasSelectedCourse="hasSelectedCourse"
        :selectedCourseTitle="selectedCourseTitle"
        @selectCourse="selectCourse(course)"/>
    </v-content>

    <v-footer class="pl-footer" height="auto">
      <v-card width="100%" class="text-xs-center">
        <v-card-text>
          <p>
            Aplicação 100% desenvolvida in-house, feita de jogadores
            de poker para jogadores de poker!
          </p>

          <p>
            &copy; 2018 - 2020
            <a
              target="_blank"
              href="https://pokerlab.com.br/">PokerLAB Premium</a> —
            <a
              target="_blank"
              href="https://vfx3.com.br/">by Grupo VFX</a>
          </p>
        </v-card-text>
      </v-card>
    </v-footer>

    <alert ref="alert"></alert>
    <confirm ref="confirm"></confirm>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import Alert from '@/components/Alert'
import Confirm from '@/components/Confirm'
import localforage from 'localforage'

export default {
  name: 'Dashboard',

  components: {
    Alert,
    Confirm
  },

  data () {
    return {
      clipped: false,
      fixed: false,
      drawer: true,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      list: {
        status: false
      },
      selectedCourse: ''
    }
  },

  mounted () {
    this.getAllSubcategories()
    this.$root.$confirm = this.$refs.confirm.open
    this.$root.$alert = this.$refs.alert.open
  },

  methods: {
    ...mapActions('categories', ['getCategories']),
    ...mapActions('subcategories', ['getAllSubcategories']),
    ...mapActions('auth', ['signOut', 'removeUser']),
    ...mapActions('courses', ['setCourse']),
    ...mapActions('ranges', ['getRanges']),

    selectCourse (course) {
      this.setCourse(course)
      this.getCategories(course)

      if (this.$router.history.current.name !== 'home') {
        this.$router.replace({ name: 'home' })
      }
    },

    logout () {
      let that = this
      firebase.auth().signOut()
        .then(function () {
          localforage.removeItem('currentUser').then(() => {
            that.removeUser()
            that.$router.push({ name: 'auth.index' })
          })
        })
        .catch(error => console.log('🤷‍️ ' + error))
    }
  },

  computed: {
    ...mapGetters('categories', ['currentCategories']),
    ...mapGetters('courses', ['currentCourse']),
    ...mapGetters('ranges', ['currentRanges']),
    ...mapState('subcategories', ['subcategories']),
    ...mapGetters({
      subcategoriesByCategoryId: 'subcategories/subcategoriesByCategoryId',
      currentUser: 'auth/currentUser',
      loggedIn: 'auth/loggedIn',
      courses: 'auth/courses'
    }),

    hasSelectedCourse () {
      return this.currentCourse
    },

    selectedCourseTitle () {
      if (this.currentCourse) {
        return this.currentCourse.title
      } else {
        return 'Selecione o Curso'
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        next()
      } else {
        next({ name: 'login_path', query: { redirectTo: to.fullPath } })
      }
    })
  }
}
</script>

<style lang="scss">
  @import '@/design/index.scss';
</style>
